<template>
  <div class="wrap">
    <div class="search-wrap">
      <el-input
        v-model="coach_name"
        placeholder="搜索教练名称"
        prefix-icon="el-icon-search"
        class="input-search"
        @keyup.enter.native="getCoach"
      ></el-input>
    </div>
    <el-table :data="tableData">
      <el-table-column label="序号" type="index" width="50px"></el-table-column>
      <el-table-column label="教练姓名" prop="coach_name"></el-table-column>
      <el-table-column label="可预约时间" prop="time_h"></el-table-column>
      <el-table-column label="取消提前限制（小时）" prop="cancel_time"></el-table-column>
      <el-table-column label="允许取消次数（次/日）" prop="cancel_num"></el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button @click="setBtn(scope.row)" type="text">设置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-dialog :title="msgTitle" :visible.sync="visible" width="500px">
      <el-form :model="from" label-width="100px">
        <el-form-item label="允许取消次数">
          <el-input v-model="from.cancel_num"></el-input>
        </el-form-item>
        <el-form-item label="取消提前限制">
          <el-input v-model="from.cancel_time"></el-input>
        </el-form-item>
        <el-form-item label="预约时间设置">
          <el-date-picker
                size="small"
                v-model="from.time"
                type="daterange"
                :unlink-panels ="unlink"
                format="yyyy 年 MM 月 dd 日"
                range-separator="-"
                :clearable="!unlink"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注提醒">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model="from.remind"
            auto-complete="off"
            placeholder="请输入备注提醒"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="close">取消</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 检索词
      coach_name: "",
      tableData: [],
      visible: false,
      msgTitle: '',
      unlink: true,
      from: {
        coach_id: 0,
        cancel_num: 0,
        cancel_time: 0,
        time: [],
        remind: ''
      },
      // 分页
      page: 1,
      page_size: 10,
      total: 0
    };
  },
  methods: {
    // 设置
    setBtn(row) {
      this.from.coach_id = row.coach_id
      this.from.cancel_num = row.cancel_num;
      this.from.cancel_time = row.cancel_time;
      this.from.time = [];
      this.from.remind = row.remind;
      this.msgTitle = "设置";
      this.visible = true;
    },
    // 保存
    submit() {
      this.$http.post('index.php/admin/coach/coachAppointmentSet', { 
        coach_id: this.from.coach_id,
        cancel_num: this.from.cancel_num,
        cancel_time: this.from.cancel_time,
        start_time: this.from.time[0],
        end_time: this.from.time[1],
        remind: this.from.remind
       }).then(res => {
        this.$message(res.msg);
        this.visible = false;
      });
    },
    // 关闭
    close() {
      this.from.coach_id = 0;
      this.from.cancel_num = 0;
      this.from.cancel_time = 0;
      this.from.time = [];
      this.from.remind = '';
      this.visible = false;
    },
    // 翻页
    handleCurrentChange(v) {
      this.page = v;
      this.getCoach();
    },
    // 设置每页条数
    handleSizeChange(v) {
      this.page_size = v;
      this.getCoach();
    },
    // 获取列表
    getCoach() {
      this.$http
        .post("/index.php/admin/coach/coachAppointmentList", { coach_name: this.coach_name,page: this.page, page_size: this.page_size })
        .then(res => {
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
    },
  },
  created() {
    this.getCoach();
  }
};
</script>
<style lang="scss" scoped>
.input-wrap {
  display: flex;
  .el-input {
    margin-right: 5px;
  }
}
</style>
